import { render, staticRenderFns } from "./NavList.vue?vue&type=template&id=72593346&scoped=true&"
import script from "./NavList.vue?vue&type=script&lang=js&"
export * from "./NavList.vue?vue&type=script&lang=js&"
import style0 from "./NavList.vue?vue&type=style&index=0&id=72593346&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72593346",
  null
  
)

export default component.exports